var _defs, _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmoke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 22.56,
    y1: 21.96,
    x2: 39.2,
    y2: 50.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deeafb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 30.25,
    y1: 48.4,
    x2: 33.25,
    y2: 53.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8bdc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#b8bdc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5aab2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 23.5,
    y1: 38.1,
    x2: 28,
    y2: 45.9,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 33.75,
    y1: 28.8,
    x2: 39.75,
    y2: 39.2,
    xlinkHref: "#b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5,31.5l-.32,0a10.49,10.49,0,0,0-19.11-8,7,7,0,0,0-10.57,6,7.21,7.21,0,0,0,.1,1.14A7.5,7.5,0,0,0,18,45.5a4.19,4.19,0,0,0,.5,0v0h28a7,7,0,0,0,0-14Z",
    stroke: "#e6effc",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#a)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.75,
    cy: 51,
    r: 3,
    stroke: "#afb4bc",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#b)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 0; 0 -17;",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0; 1; 1; 1; 0",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3; 4.5; 6",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.75,
    cy: 51,
    r: 4.5,
    stroke: "#afb4bc",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#c)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 0; 0 -17;",
    dur: "3s",
    begin: "-1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0; 1; 1; 1; 0",
    dur: "3s",
    begin: "-1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3; 4.5; 6",
    dur: "3s",
    begin: "-1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "31.75; 25.75",
    dur: "3s",
    begin: "-1s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.75,
    cy: 51,
    r: 6,
    stroke: "#afb4bc",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#d)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 0; 0 -17;",
    dur: "3s",
    begin: "-2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0; 1; 1; 1; 0",
    dur: "3s",
    begin: "-2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3; 4.5; 6",
    dur: "3s",
    begin: "-2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "31.75; 36.75",
    dur: "3s",
    begin: "-2s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoke);
export default __webpack_public_path__ + "static/media/smoke.4bdbc45d7f271a7dabb2d9c39a3eacfc.svg";
export { ForwardRef as ReactComponent };